
interface IconProps{
    src:string
    alt:string
    className?:any
}

export const Icon:React.FC<IconProps>=({src,alt,className})=>{
    return <img src={src} alt={alt} className={`icon ${className}`} />
}